module.exports = __webpack_public_path__ + "static/case_study-d1d136b3ecef34bc5a80e3fcaa91f5b8.svg";